module.exports = __webpack_public_path__ + "b8fd5b226d029beb32b8814fed081c55.pdf";